import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const StiHivTesting = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 pb-md-4 pb-4'>
        <Row className='reversesection'>
        <Col md='12' lg='7' className=''>

            <div className=''>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    HIV Testing For Your Better Health
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='py-2'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px', textAlign:'justify'}}>
                According to the Centers for Disease Control and Prevention (CDC), routine health care recommends that individuals between the ages of 13 and 64 undergo HIV testing at least once, with higher-risk individuals being tested more frequently. If you are 64 or older and at risk for HIV, your healthcare provider might advise HIV testing.
                </div>
            </div>

            <div className='pt-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px', textAlign:'justify'}}>
                HIV testing can be conducted either confidentially or anonymously. Confidential testing involves including your name and other identifying information in your HIV test results, which are documented in your medical records. Positive results are reported to local or state health departments for statistical purposes, with personal details such as names and addresses removed before sharing the information with the CDC. The CDC uses this data solely for reporting and does not disclose it to other entities, including insurance companies. On the other hand, anonymous testing allows you to undergo an HIV test without revealing your name. Instead, you receive a unique number that you provide when retrieving your test results.
                </div>
            </div>
        </Col>

        <Col className='pt-lg-4 pt-md-5'>
            <div className='pb-md-0 pb4 flex-center10'>
                <img src='sti-testing/STI-Testing-img2-v1.png' alt='sti-testing' height='auto' width='' className='img-w5' />
            </div>
        </Col>
        </Row>
        </div>

        <div className='pt-md-5 pt-4 left-padding6rem right-padding6rem'>
            <div className='left-padding8rem right-padding8rem ' style={{ }}>
                <div className='bg-img rounded30 py-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)', backgroundImage:'url("sti-testing/RSV-Testing-bg2.png")', width:'100%'}}>
                    <div className='p-3'>
                    <text className='fs-ss-26-5 text-montserrat text-white fw-600 lh-1-2'>
                        <center>
                            NEED STI / STD TESTING SERVICES IN CHICAGO, IL?
                        </center>
                    </text>    
                    </div>

                    <div className='pb-3 pt-md-2'>
                        <center>
                        <Link to='/sti-std-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    Book Appointment Now
                                </text>
                            </Button>
                        </Link>
                        </center>
                    </div>
                </div>
            </div>
            </div>
    </div>
  )
}

export default StiHivTesting